import React from "react";
import { NavLink } from "react-router-dom";
import direction from "../../../service/direction.json";
const CloudLandlineReseller = () => {
  return (
    <div className="form-group row col-md-12 text-justify">
      <div className="col-md-8">
        <div style={{ width: "18rem;", fontSize: "20px" }}>
          <div className="card-body">
            <h5 className="card-title text-bold" style={{ fontSize: "30px" }}>
              نمایندگی فروش تلفن ثابت ابری
            </h5>
            <p className="card-text">
              درسایه بان سرویس جدیدی با عنوان تلفن ثابت ابری یا همان تلفن
              اینترنتی ارائه میشود که از پیش شماره هر شهر دلخواه میتوانید تهیه
              کرده و از امکانات تلفن سانترال بصورت مجازی و بدون هیچ تجهیزاتی
              استفاده کنید مانند تعریف داخلی های مختلف، صف تماس، ارسال فکس و حتی
              برقراری تماس خروجی
              <br />
              قبل از اینکه درمورد هزینه ها و درآمدزایی این سرویس برای نمایندگان
              صحبت کنیم حتما ابتدا برگه ای که توضیحات کامل این سرویس را بیان
              کرده ایم را بخوایند:
            </p>
            <div className="text-center">
              <NavLink to="/VOPInfo" className="btn btn-info">
                امکانات و هزینه های کاربری تلفن ثابت ابری
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4 text-center">
        <img
          src={`${direction.ImgDesign}phone_web_SIP_Trunk.png`}
          alt="سایه بان"
        />
      </div>
    </div>
  );
};

export default CloudLandlineReseller;
